import { Route, Routes } from 'react-router-dom'
import {
  contractCategoryDetailsRoute,
  contractCategoryDetailsRoutes
} from './routes'
import { General } from './General/General'
import Users from './Users/Users'

export const ContractCategoryDetailsRouter = () => (
  <Routes>
    {contractCategoryDetailsRoutes.map((route) => (
      <Route key={route.path} path={route.path} element={<route.component />} />
    ))}
    <Route path={contractCategoryDetailsRoute.users} element={<Users />}>
      <Route path={':subtab'} element={<Users />} />
    </Route>
    <Route index element={<General />} />
  </Routes>
)
